import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Modal,
  Button,
  Row,
  Col,
  Form,
  Table,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  editDisciplinaryActions,
  saveDisciplinaryActions,
} from "../../redux/Modulo_Sanciones/Disciplinary_Actions/actions";
import { getDisciplinaryMeasurement } from "../../redux/Modulo_Sanciones/Disciplinary_Measurement/actions";
import { getUnlinkCategories } from "../../redux/Modulo_Sanciones/Unlink_Categories/actions";
import { getUnlinkTemplates } from "../../redux/Modulo_Sanciones/Unlink_Templates/actions";
import { getResponsables } from "../../redux/climalaboral/campaña/action";
import { getWorkflows } from "../../redux/on&offBoarning/workflow/actions";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  getDisciplinaryCase,
  resetDisciplinaryCase,
} from "../../redux/Modulo_Sanciones/diciplinarycase/actions";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import moment from "moment";
import LinkDescargaGD from "../gestorDocumental/LinkDescargaGD";

const Disciplinary_Actions_Modal = (props) => {
  //*States
  const [userSelected, setUserSelected] = useState("");
  const [validated, setValidated] = useState(false);
  const [emailArray, setEmailArray] = useState([]);
  const [timer, setTimer] = useState(null);
  const [validEmail, setValidEmail] = useState(false);
  const [medidadDis, setMedidadDis] = useState(false);
  const [respSelected, setRespSelected] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  const [catSelected, setCatSelected] = useState([]);
  const [medSelected, setMedSelected] = useState([]);
  const [caseSelected, setCaseSelected] = useState([]);
  const [hablitarSubir, setHablitarSubir] = useState(false);
  const [docSubir, setDocSubir] = useState([]);
  //*Redux
  const {
    userId,
    // userRoles
  } = useSelector((store) => store.auth);
  const { saveLoading, formError, emailError } = useSelector(
    (store) => store.disciplinaryActions
  );
  const { loading, disciplinaryMeasurement, disciplinaryMeasurementError } =
    useSelector((store) => store.disciplinaryMeasurement);
  const { unlinkCategories, unlinkCategoriesError } = useSelector(
    (store) => store.unlinkCategories
  );
  const loadingUnlinkCategories = useSelector(
    (store) => store.unlinkCategories.loading
  );
  const { responsable, responsableLoading } = useSelector(
    (store) => store.campaña
  );
  const { workflows } = useSelector((store) => store.workflow);
  const workflowError = useSelector((store) => store.workflow.error);
  const loadingWorkFlow = useSelector((store) => store.workflow.loading);
  const {
    loaderDiciplinaryCasesAll: loaderDiciplinaryCases,
    loaderDiciplinaryCase,
    disciplinaryCasesAll: disciplinaryCases,
    disciplinaryCasesFaildAll: disciplinaryCasesFaild,
    disciplinaryCase,
  } = useSelector((store) => store.disciplinaryCase);
  const { subNiveles, loadingAreas, loadingCarpetas, saveDocsLoading } =
    useSelector((store) => store.gestorDocumental);

  let templateOptions = [];
  workflows &&
    workflows.map((template) => {
      if (parseInt(template.tipo_workflow) === 2) {
        templateOptions = [
          ...templateOptions,
          {
            id: template.id,
            label: `${template.nombre}`,
          },
        ];
      }
    });
  let responsableOptions = [];
  responsable &&
    responsable.map((user) => {
      responsableOptions = [
        ...responsableOptions,
        {
          id: user.id,
          label: `${user.username}-${user.first_name} ${user.last_name}`,
        },
      ];
    });
  let categoryOptions = [];
  unlinkCategories &&
    unlinkCategories.map((categ) => {
      categoryOptions = [
        ...categoryOptions,
        {
          id: categ.id,
          label: `${categ.nombre}`,
        },
      ];
    });
  let medicionOptions = [];
  disciplinaryMeasurement &&
    disciplinaryMeasurement.map((med) => {
      medicionOptions = [
        ...medicionOptions,
        {
          id: med.id,
          label: `${med.nombre}`,
        },
      ];
    });
  let caseOptions = [];
  disciplinaryCases &&
    disciplinaryCases.data &&
    disciplinaryCases.data.map((cas) => {
      caseOptions = [
        ...caseOptions,
        {
          id: cas.id,
          label: `${cas.caso_disciplinario}`,
        },
      ];
    });

  const schema = Yup.object().shape({
    caso_disciplinario: Yup.string().required("**Campo requerido"),
    medida_disciplinaria: Yup.string().required("**Campo requerido"),
    calculo_prestaciones: Yup.string()
      .matches(/[\w]/, "Formato no correcto")
      .notRequired(),
    observacion: Yup.string()
      .matches(/[\w]/, "Formato no correcto")
      .required("**Campo requerido"),
    autorizado_por: Yup.string()
      .ensure()
      .when("medida_disciplinaria", {
        is: (medida_disciplinaria) => medida_disciplinaria && medidadDis,
        then: Yup.string().required("**Campo requerido"),
      }),
    id_plantilla: Yup.string()
      .ensure()
      .when("medida_disciplinaria", {
        is: (medida_disciplinaria) =>
          medida_disciplinaria &&
          medidadDis &&
          !props.editItem.off_bording &&
          disciplinaryCase &&
          disciplinaryCase.list_id_usuario,
        then: Yup.string().required("**Campo requerido"),
      }),
    id_responsable: Yup.string()
      .ensure()
      .when("medida_disciplinaria", {
        is: (medida_disciplinaria) =>
          medida_disciplinaria &&
          medidadDis &&
          !props.editItem.off_bording &&
          disciplinaryCase &&
          disciplinaryCase.list_id_usuario,
        then: Yup.string().required("**Campo requerido"),
      }),
    categoria_desvinculacion: Yup.string()
      .ensure()
      .when("medida_disciplinaria", {
        is: (medida_disciplinaria) => medida_disciplinaria && medidadDis,
        then: Yup.string().required("**Campo requerido"),
      }),
    archivo_autorizacion: Yup.mixed()
      .test("200000000", "Uploaded file is too big.", (value) => {
        return value && filesharhe_ref.current
          ? filesharhe_ref.current.files[0].size <= 200000000
            ? true
            : false
          : true;
      })
      .when("medida_disciplinaria", {
        is: (medida_disciplinaria) =>
          medida_disciplinaria &&
          medidadDis &&
          props.edit &&
          props.editItem.archivo_autorizacion,
        then: Yup.mixed().required("**Campo requerido"),
      }),
      fecha_creacion: Yup.date().required("**Campo requerido"),
  });
  //*variables
  const dispatch = useDispatch();
  const filesharhe_ref = useRef();
  //* Methods
  useEffect(() => {
    dispatch(getUnlinkTemplates({}));
    dispatch(getUnlinkCategories({}));
    dispatch(getResponsables({ rol_responsable: "Responsable_OffBoarding" }));
    dispatch(getWorkflows({}));
    dispatch(getDisciplinaryMeasurement({}));
  }, []);

  // useEffect(() => {
  //   if (
  //     userRoles.length > 0 &&
  //     userRoles.includes("jefe") &&
  //     !(
  //       userRoles.includes("Responsable_Sanciones") ||
  //       userRoles.includes("Encargado_Sanciones") ||
  //       userRoles.includes("administrador")
  //     )
  //   ) {
  //     dispatch(
  //       getDisciplinaryMeasurement({
  //         tipo_busqueda: "mostrar_jefe",
  //         filter: "True",
  //       })
  //     );
  //   } else {
  //     dispatch(getDisciplinaryMeasurement({}));
  //   }
  // }, [userRoles]);

  const emailSubmit = (e) => {
    setEmailArray([...emailArray, userSelected]);
    setUserSelected("");
    document.getElementById("email").value = "";
    setValidEmail(false);
  };

  const handleRemoveEmail = (ind) => {
    const emailT = emailArray.slice();
    emailT.splice(ind, 1);
    setEmailArray(emailT);
  };

  const onSubmit = async (req) => {
    const _req = {
      aplicada_por: parseInt(userId),
      observacion: req.observacion,
      caso_disciplinario: parseInt(req.caso_disciplinario),
      medida_disciplinaria: parseInt(req.medida_disciplinaria),
      off_bording: props.edit ? props.editItem.off_bording : null,
      categoria_desvinculacion: props.edit
        ? props.editItem.categoria_desvinculacion
        : null,
      // archivo_autorizacion: props.edit ? props.editItem.archivo_autorizacion : null,
      autorizado_por: props.edit ? props.editItem.autorizado_por : null,
      calculo_prestaciones: req.calculo_prestaciones,
      fecha_creacion: moment(req.fecha_creacion).format("YYYY-MM-DD hh:mm:ss"),
    };
    const reqWF = {
      empleados: [
        {
          empleado: null,
          responsable: null,
        },
      ],
      workflow: null,
    };

    if (props.edit) {
      if (
        medidadDis &&
        !props.editItem.off_bording &&
        disciplinaryCase &&
        disciplinaryCase.list_id_usuario
      ) {
        _req.categoria_desvinculacion = parseInt(req.categoria_desvinculacion);
        reqWF.empleados[0].responsable = parseInt(req.id_responsable);
        reqWF.workflow = parseInt(req.id_plantilla);
        if (disciplinaryCase && disciplinaryCase.list_id_usuario) {
          reqWF.empleados[0].empleado = parseInt(
            disciplinaryCase.list_id_usuario[0].id
          );
        }
      }
      _req.fecha_creacion = props.editItem.fecha_creacion;
    } else {
      if (medidadDis && disciplinaryCase && disciplinaryCase.list_id_usuario) {
        _req.categoria_desvinculacion = parseInt(req.categoria_desvinculacion);
        reqWF.empleados[0].responsable = parseInt(req.id_responsable);
        reqWF.workflow = parseInt(req.id_plantilla);
        if (disciplinaryCase && disciplinaryCase.list_id_usuario) {
          reqWF.empleados[0].empleado = parseInt(
            disciplinaryCase.list_id_usuario[0].id
          );
        }
      }
    }

    var _archivoEvidencia = {};
    if (medidadDis) {
      _req.autorizado_por = req.autorizado_por;
      if (docSubir.length > 0) {
        const oArea = props.areas.find(
          (item) => item.descripcion.toLowerCase() === props.area.toLowerCase()
        );
        const oCarpeta = props.carpetas.find(
          (item) =>
            item.descripcion.toLowerCase() === props.carpeta.toLowerCase()
        );

        const filebase64 = await getBase64(docSubir[0]);
        const fileName = docSubir[0].name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");

        _archivoEvidencia = {
          id_empleado: parseInt(disciplinaryCase.list_codigo_empleado[0].id),
          tipo_documento: props.tipoDocumento,
          archivo: aFileBase[1],
          contentTypeGD: `${aFileBase[0]},`,
          origen: fName + fExt,
          extension: fExt,
          tipo_documento_GD: props.tipoDocumentoGD,
          descripcion: props.descripcion,
          fecha: moment().format("YYYY-MM-DD"),
          id_area: oArea.id,
          id_carpeta_encabezado: oCarpeta.id,
          empresa: disciplinaryCase.list_codigo_empleado[0].empresa[0],
          zona: disciplinaryCase.list_codigo_empleado[0]
            .Division_Personal_List[0].descripcion,
          id_registro: props.edit ? parseInt(props.editItem.id) : null,
        };
      }
    }

    if (!props.edit) {
      dispatch(
        saveDisciplinaryActions(
          _req,
          emailArray,
          reqWF,
          medidadDis,
          disciplinaryCase,
          _archivoEvidencia,
          setRespSelected,
          setTempSelected,
          setCatSelected,
          setMedSelected,
          setCaseSelected,
          setMedidadDis,
          props.handleClose
        )
      );
    } else {
      dispatch(
        editDisciplinaryActions(
          _req,
          props.editItem,
          props.index,
          emailArray,
          reqWF,
          medidadDis,
          disciplinaryCase,
          _archivoEvidencia,
          setRespSelected,
          setTempSelected,
          setCatSelected,
          setMedSelected,
          setCaseSelected,
          setMedidadDis,
          props.handleClose,
          docSubir
        )
      );
    }
    // setRespSelected([]);
    // setTempSelected([]);
    // setCatSelected([]);
    // setMedSelected([]);
    // setCaseSelected([]);
    // setMedidadDis(false);
  };

  return (
    <Modal
      size="md"
      show={props.show}
      onHide={() => {
        props.handleClose();
        setUserSelected("");
        setEmailArray([]);
        setMedidadDis(false);
        setRespSelected([]);
        setTempSelected([]);
        setMedSelected([]);
        setCatSelected([]);
        setCaseSelected([]);
        setHablitarSubir(false);
        setDocSubir([]);
      }}
      onShow={() => {
        setValidated(false);
        if (props.edit) {
          if (props.editItem.autorizado_por) {
            setHablitarSubir(true);
          } else {
            setHablitarSubir(false);
          }
          setMedSelected([
            {
              id: props.editItem.list_medida[0].id,
              label: props.editItem.list_medida[0].nombre,
            },
          ]);
          setCaseSelected([
            {
              id: props.editItem.list_caso_disciplinario[0].id,
              label:
                props.editItem.list_caso_disciplinario[0].caso_disciplinario,
            },
          ]);
          dispatch(
            getDisciplinaryCase(props.editItem.list_caso_disciplinario[0].id)
          );
          if (
            props.editItem.list_medida[0].nombre.toLowerCase() ===
            "desvinculación".toLowerCase()
          ) {
            setCatSelected([
              {
                id: props.editItem.list_categoria_desvinculacion[0].id,
                label: props.editItem.list_categoria_desvinculacion[0].nombre,
              },
            ]);
            setMedidadDis(true);
          } else {
            setMedidadDis(false);
          }
        }
      }}
    >
      <Formik
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={{
          caso_disciplinario: props.edit
            ? props.editItem.caso_disciplinario === null
              ? ""
              : props.editItem.caso_disciplinario
            : "",
          medida_disciplinaria: props.edit
            ? props.editItem.medida_disciplinaria === null
              ? ""
              : props.editItem.medida_disciplinaria
            : "",
          calculo_prestaciones: props.edit
            ? props.editItem.calculo_prestaciones === null
              ? ""
              : props.editItem.calculo_prestaciones
            : "",
          observacion: props.edit
            ? props.editItem.observacion === null
              ? ""
              : props.editItem.observacion
            : "",
          autorizado_por: props.edit
            ? props.editItem.autorizado_por === null
              ? ""
              : props.editItem.autorizado_por
            : "",
          categoria_desvinculacion: props.edit
            ? props.editItem.categoria_desvinculacion === null
              ? ""
              : props.editItem.categoria_desvinculacion
            : "",
          fecha_creacion: props.edit ? moment(props.editItem.fecha_creacion).format('YYYY-MM-DD') : "",
          id_plantilla: "",
          id_responsable: "",
          archivo_autorizacion: [],
        }}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
        }) => (
          <Form onSubmit={handleSubmit} noValidate validated={validated}>
            <Modal.Header closeButton>
              <Modal.Title className="text-muted">
                {props.edit
                  ? "Editar acción disciplinaria"
                  : "Crear acción disciplinaria"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {!!formError && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {formError}
                </Alert>
              )}
              {!!disciplinaryMeasurementError && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {disciplinaryMeasurementError}
                </Alert>
              )}
              {!!unlinkCategoriesError && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {unlinkCategoriesError}
                </Alert>
              )}
              {!!workflowError && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {workflowError}
                </Alert>
              )}
              {!!emailError && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {emailError}
                </Alert>
              )}
              {!!disciplinaryCasesFaild && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {disciplinaryCasesFaild}
                </Alert>
              )}
              <Form.Group as={Col} className="mb-1">
                <Form.Label column sm="12" md="12">
                  Caso disciplinario activo
                </Form.Label>
                <Col>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col
                      className=" px-0"
                      sm={loaderDiciplinaryCases ? "11" : "12"}
                    >
                      <Typeahead
                        id="caso_disciplinario"
                        name="caso_disciplinario"
                        isInvalid={
                          touched.caso_disciplinario &&
                          errors.caso_disciplinario
                        }
                        isValid={
                          touched.caso_disciplinario &&
                          !errors.caso_disciplinario
                        }
                        onBlur={handleBlur("caso_disciplinario")}
                        placeholder="Seleccione un caso disciplinario"
                        options={caseOptions}
                        onChange={(selected) => {
                          if (!props.edit) {
                            setFieldValue(
                              "caso_disciplinario",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setCaseSelected(selected);
                            if (selected.length > 0) {
                              dispatch(getDisciplinaryCase(selected[0].id));
                            } else {
                              dispatch(resetDisciplinaryCase());
                            }
                          }
                        }}
                        disabled={
                          loaderDiciplinaryCases ||
                          props.edit ||
                          (props.view &&
                            !(
                              props.view === "administrador" ||
                              props.view === "Encargado_Sanciones" ||
                              props.view === "Responsable_Sanciones"
                            )) ||
                          // (userRoles.length > 0 &&
                          //   !(
                          //     userRoles.includes("Responsable_Sanciones") ||
                          //     userRoles.includes("Encargado_Sanciones") ||
                          //     userRoles.includes("administrador")
                          //   ))
                          (props.edit &&
                            props.editItem.list_caso_disciplinario[0]
                              .fecha_cierre)
                        }
                        selected={caseSelected}
                      ></Typeahead>
                    </Col>
                    {loaderDiciplinaryCases && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Row>
                </Col>
                {touched.caso_disciplinario && errors.caso_disciplinario && (
                  <div>
                    <small className="text-danger">
                      {errors.caso_disciplinario}
                    </small>
                  </div>
                )}
              </Form.Group>
              <Form.Group as={Col} className="mb-1">
                <Form.Label column sm="12" md="12">
                  Medidas diciplinarias
                </Form.Label>
                <Col>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col className=" px-0" sm={loading ? "11" : "12"}>
                      <Typeahead
                        id="medida_disciplinaria"
                        name="medida_disciplinaria"
                        isInvalid={
                          touched.medida_disciplinaria &&
                          errors.medida_disciplinaria
                        }
                        isValid={
                          touched.medida_disciplinaria &&
                          !errors.medida_disciplinaria
                        }
                        onBlur={handleBlur("medida_disciplinaria")}
                        placeholder="Seleccione una medida diciplinaria"
                        options={medicionOptions}
                        onChange={(selected) => {
                          setFieldValue(
                            "medida_disciplinaria",
                            selected.length > 0 ? selected[0].id : ""
                          );
                          setMedSelected(selected);
                          setMedidadDis(
                            selected.length > 0 &&
                              selected[0] &&
                              selected[0].label !== "" &&
                              selected[0].label.toLowerCase() ===
                                "desvinculación".toLowerCase()
                              ? true
                              : false
                          );
                        }}
                        selected={medSelected}
                        disabled={
                          loading ||
                          (props.view &&
                            !(
                              props.view === "administrador" ||
                              props.view === "Encargado_Sanciones" ||
                              props.view === "Responsable_Sanciones"
                            )) ||
                          // (userRoles.length > 0 &&
                          //   !(
                          //     userRoles.includes("Responsable_Sanciones") ||
                          //     userRoles.includes("Encargado_Sanciones") ||
                          //     userRoles.includes("administrador")
                          //   ))
                          (props.edit &&
                            props.editItem.list_caso_disciplinario[0]
                              .fecha_cierre)
                        }
                      ></Typeahead>
                    </Col>
                    {loading && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Row>
                </Col>
                {touched.medida_disciplinaria &&
                  errors.medida_disciplinaria && (
                    <div>
                      <small className="text-danger">
                        {errors.medida_disciplinaria}
                      </small>
                    </div>
                  )}
              </Form.Group>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column>Calculo de prestaciones (Monto)</Form.Label>
                <Form.Control
                  id="calculo_prestaciones"
                  name="calculo_prestaciones"
                  isInvalid={
                    touched.calculo_prestaciones && errors.calculo_prestaciones
                  }
                  isValid={
                    touched.calculo_prestaciones && !errors.calculo_prestaciones
                  }
                  onBlur={handleBlur("calculo_prestaciones")}
                  onChange={handleChange}
                  value={values.calculo_prestaciones}
                  className="rounded-pill"
                  type="text"
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$"
                  placeholder="00.00"
                  disabled={
                    (props.view &&
                      !(
                        props.view === "administrador" ||
                        props.view === "Encargado_Sanciones" ||
                        props.view === "Responsable_Sanciones"
                      )) ||
                    // (userRoles.length > 0 &&
                    //   !(
                    //     userRoles.includes("Responsable_Sanciones") ||
                    //     userRoles.includes("Encargado_Sanciones") ||
                    //     userRoles.includes("administrador")
                    //   )) ||
                    (props.edit &&
                      props.editItem.list_caso_disciplinario[0].fecha_cierre)
                  }
                ></Form.Control>
                {touched.calculo_prestaciones &&
                  errors.calculo_prestaciones && (
                    <div>
                      <small className="text-danger">
                        {errors.calculo_prestaciones}
                      </small>
                    </div>
                  )}
              </Form.Group>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column sm="12" md="12">
                  Observación :
                </Form.Label>
                <Form.Control
                  id="observacion"
                  name="observacion"
                  isInvalid={touched.observacion && errors.observacion}
                  isValid={touched.observacion && !errors.observacion}
                  onBlur={handleBlur("observacion")}
                  onChange={handleChange}
                  value={values.observacion}
                  as="textarea"
                  placeholder="Observación de la acción disciplinaria"
                  disabled={
                    (props.view &&
                      !(
                        props.view === "administrador" ||
                        props.view === "Encargado_Sanciones" ||
                        props.view === "Responsable_Sanciones"
                      )) ||
                    // (userRoles.length > 0 &&
                    //   !(
                    //     userRoles.includes("Responsable_Sanciones") ||
                    //     userRoles.includes("Encargado_Sanciones") ||
                    //     userRoles.includes("administrador")
                    //   )) ||
                    (props.edit &&
                      props.editItem.list_caso_disciplinario[0].fecha_cierre)
                  }
                ></Form.Control>
                {touched.observacion && errors.observacion && (
                  <div>
                    <small className="text-danger">{errors.observacion}</small>
                  </div>
                )}
              </Form.Group>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column sm="12" md="12">
                  Correo electronico
                </Form.Label>
                <Form.Control
                  name="email"
                  id="email"
                  className="rounded-pill"
                  type="text"
                  isInvalid={!validEmail && userSelected}
                  isValid={validEmail && userSelected}
                  defaultValue={null}
                  onChange={(e) => {
                    let valueTemp = e.currentTarget.value;
                    clearTimeout(timer);

                    const newTimer = setTimeout(() => {
                      setUserSelected(valueTemp);
                      if (
                        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(
                          valueTemp
                        )
                      ) {
                        setValidEmail(true);
                      } else {
                        setValidEmail(false);
                      }
                    }, 500);

                    setTimer(newTimer);
                  }}
                  placeholder="Correo electronico"
                  disabled={
                    (props.view &&
                      !(
                        props.view === "administrador" ||
                        props.view === "Encargado_Sanciones" ||
                        props.view === "Responsable_Sanciones"
                      )) ||
                    // (userRoles.length > 0 &&
                    //   !(
                    //     userRoles.includes("Responsable_Sanciones") ||
                    //     userRoles.includes("Encargado_Sanciones") ||
                    //     userRoles.includes("administrador")
                    //   )) ||
                    (props.edit &&
                      props.editItem.list_caso_disciplinario[0].fecha_cierre)
                  }
                ></Form.Control>
                {!validEmail && userSelected !== "" && (
                  <>
                    <span className="text-danger pl-1">
                      **Ingrese un correo electronico valido.
                    </span>
                  </>
                )}
              </Form.Group>
              <Form.Group as={Col} className="mb-3">
                <Form.Label column sm="12" md="12">
                  Fecha de creación
                </Form.Label>
                <Form.Control
                  name="fecha_creacion"
                  id="fecha_creacion"
                  className="rounded-pill"
                  type="date"
                  isInvalid={touched.fecha_creacion && errors.fecha_creacion}
                  isValid={touched.fecha_creacion && !errors.fecha_creacion}
                  onBlur={handleBlur("fecha_creacion")}
                  onChange={handleChange}
                  value={values.fecha_creacion}
                  placeholder="Fecha de creación"
                  disabled={
                    (props.view &&
                      !(
                        props.view === "administrador" ||
                        props.view === "Encargado_Sanciones" ||
                        props.view === "Responsable_Sanciones"
                      )) ||
                    // (userRoles.length > 0 &&
                    //   !(
                    //     userRoles.includes("Responsable_Sanciones") ||
                    //     userRoles.includes("Encargado_Sanciones") ||
                    //     userRoles.includes("administrador")
                    //   )) ||
                    (props.edit &&
                      props.editItem.list_caso_disciplinario[0].fecha_creacion) ||
                    props.edit
                  }
                ></Form.Control>
              </Form.Group>
              <Col className="mt-3">
                <Button
                  disabled={!validEmail || (!validEmail && userSelected === "")}
                  className="rounded ml-1"
                  variant="primary"
                  type="button"
                  onClick={emailSubmit}
                >
                  Agregar
                </Button>
              </Col>
              <Row className="mt-3 px-3">
                <Col>
                  <div>
                    {emailArray.length > 0 ? (
                      <div
                        class="table-responsive"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        <Table striped>
                          <thead>
                            <tr>
                              <th>Correo</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {emailArray.map((email, ind) => (
                              <tr key={ind}>
                                <td>{email}</td>
                                <td>
                                  <Button
                                    variant="default"
                                    size="sm"
                                    className="ml-3"
                                    onClick={() => handleRemoveEmail(ind)}
                                  >
                                    <i
                                      className="material-icons"
                                      style={{ fontSize: "1.3rem" }}
                                    >
                                      delete
                                    </i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <Alert variant="info">
                        Aún no hay correos ingresados.
                      </Alert>
                    )}
                  </div>
                </Col>
              </Row>
              {medidadDis && (
                <>
                  <div className="px-2">
                    <hr />
                  </div>
                  {((disciplinaryCase && !disciplinaryCase.list_id_usuario) ||
                    !disciplinaryCase) &&
                    !loaderDiciplinaryCase && (
                      <Alert variant="danger" className="mt-4 mb-1 mx-3">
                        No se puede crear workflow porque el empleado no tiene
                        un usuario creado.
                      </Alert>
                    )}
                  {props.editItem.off_bording && (
                    <Alert variant="danger" className="mt-4 mb-1 mx-3">
                      El usuario ya se encuentra en un workflow de este tipo
                    </Alert>
                  )}
                  <Form.Group as={Col}>
                    <Form.Label column>Autorizado por</Form.Label>
                    <Form.Control
                      id="autorizado_por"
                      name="autorizado_por"
                      isInvalid={
                        touched.autorizado_por && errors.autorizado_por
                      }
                      isValid={touched.autorizado_por && !errors.autorizado_por}
                      onBlur={handleBlur("autorizado_por")}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.currentTarget.value !== "") {
                          setHablitarSubir(true);
                        } else {
                          setHablitarSubir(false);
                        }
                      }}
                      value={values.autorizado_por}
                      className="rounded-pill"
                      // required
                      type="text"
                      // defaultValue={edit ? editItem.nombre : null}
                      pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$"
                      placeholder="Autorizado por"
                      disabled={
                        (props.view &&
                          !(
                            props.view === "administrador" ||
                            props.view === "Encargado_Sanciones" ||
                            props.view === "Responsable_Sanciones"
                          )) ||
                        // (userRoles.length > 0 &&
                        //   !(
                        //     userRoles.includes("Responsable_Sanciones") ||
                        //     userRoles.includes("Encargado_Sanciones") ||
                        //     userRoles.includes("administrador")
                        //   )) ||
                        (props.edit &&
                          props.editItem.list_caso_disciplinario[0]
                            .fecha_cierre)
                      }
                    ></Form.Control>
                    {touched.autorizado_por && errors.autorizado_por && (
                      <div>
                        <small className="text-danger">
                          {errors.autorizado_por}
                        </small>
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Col sm="12" md="12">
                      <Form.Control
                        id="archivo_autorizacion"
                        name="archivo_autorizacion"
                        isInvalid={
                          touched.archivo_autorizacion &&
                          errors.archivo_autorizacion
                        }
                        isValid={
                          touched.archivo_autorizacion &&
                          !errors.archivo_autorizacion
                        }
                        innerRef={filesharhe_ref}
                        onBlur={handleBlur("archivo_autorizacion")}
                        onChange={(e) => {
                          handleChange(e);
                          setDocSubir(e.currentTarget.files);
                        }}
                        onClick={handleChange}
                        type="file"
                        value={values.archivo_autorizacion}
                        disabled={
                          !hablitarSubir ||
                          loadingAreas ||
                          loadingCarpetas ||
                          saveDocsLoading ||
                          !(
                            subNiveles &&
                            subNiveles.subNivelTipoDocList.length > 0
                          ) ||
                          !(
                            subNiveles &&
                            subNiveles.subNivelDescripcionList.length > 0
                          ) ||
                          (props.view &&
                            !(
                              props.view === "administrador" ||
                              props.view === "Encargado_Sanciones" ||
                              props.view === "Responsable_Sanciones"
                            )) ||
                          // (userRoles.length > 0 &&
                          //   !(
                          //     userRoles.includes("Responsable_Sanciones") ||
                          //     userRoles.includes("Encargado_Sanciones") ||
                          //     userRoles.includes("administrador")
                          //   )) ||
                          (props.edit &&
                            props.editItem.list_caso_disciplinario[0]
                              .fecha_cierre)
                        }
                      />
                      {touched.archivo_autorizacion &&
                        errors.archivo_autorizacion && (
                          <div>
                            <small className="text-danger">
                              {errors.archivo_autorizacion}
                            </small>
                          </div>
                        )}
                    </Col>
                  </Form.Group>
                  {props.editItem && props.editItem.archivo_autorizacion ? (
                    <>
                      <Col>
                        <h6 className="text-muted ml-3">Archivo actual</h6>
                        <ul className="list-unstyled">
                          <LinkDescargaGD
                            id={props.editItem.id}
                            filters={{
                              email: props.email,
                              id: props.editItem.list_archivo_autorizacion[0]
                                .id_documento,
                              llave:
                                props.editItem.list_archivo_autorizacion[0]
                                  .llave,
                            }}
                            origen={
                              props.editItem.list_archivo_autorizacion[0].origen
                            }
                            cType={
                              props.editItem.list_archivo_autorizacion[0]
                                .contentTypeGD
                            }
                          />
                        </ul>
                      </Col>
                    </>
                  ) : null}
                  <Form.Group as={Col}>
                    <Form.Label>Plantilla de workflow</Form.Label>
                    <Typeahead
                      id="id_plantilla"
                      name="id_plantilla"
                      isInvalid={touched.id_plantilla && errors.id_plantilla}
                      isValid={touched.id_plantilla && !errors.id_plantilla}
                      onBlur={handleBlur("id_plantilla")}
                      placeholder="Seleccione una plantilla de workflow"
                      options={templateOptions}
                      onChange={(selected) => {
                        setFieldValue(
                          "id_plantilla",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setTempSelected(selected);
                      }}
                      selected={tempSelected}
                      disabled={
                        (disciplinaryCase &&
                          !disciplinaryCase.list_id_usuario) ||
                        !disciplinaryCase ||
                        (props.edit && props.editItem.off_bording !== null) ||
                        (props.view &&
                          !(
                            props.view === "administrador" ||
                            props.view === "Encargado_Sanciones" ||
                            props.view === "Responsable_Sanciones"
                          )) ||
                        // (userRoles.length > 0 &&
                        //   !(
                        //     userRoles.includes("Responsable_Sanciones") ||
                        //     userRoles.includes("Encargado_Sanciones") ||
                        //     userRoles.includes("administrador")
                        //   )) ||
                        (props.edit &&
                          props.editItem.list_caso_disciplinario[0]
                            .fecha_cierre)
                      }
                    ></Typeahead>
                    {loadingWorkFlow && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                    {touched.id_plantilla && errors.id_plantilla && (
                      <div>
                        <small className="text-danger">
                          {errors.id_plantilla}
                        </small>
                      </div>
                    )}
                    {loaderDiciplinaryCase && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>Responsable de OffBoarding</Form.Label>
                    <Typeahead
                      id="id_responsable"
                      name="id_responsable"
                      isInvalid={
                        touched.id_responsable && errors.id_responsable
                      }
                      isValid={touched.id_responsable && !errors.id_responsable}
                      onBlur={handleBlur("id_responsable")}
                      placeholder="Seleccione un responsable de offboarding"
                      options={responsableOptions}
                      onChange={(selected) => {
                        setFieldValue(
                          "id_responsable",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setRespSelected(selected);
                      }}
                      selected={respSelected}
                      disabled={
                        (disciplinaryCase &&
                          !disciplinaryCase.list_id_usuario) ||
                        !disciplinaryCase ||
                        (props.edit && props.editItem.off_bording !== null) ||
                        (props.view &&
                          !(
                            props.view === "administrador" ||
                            props.view === "Encargado_Sanciones" ||
                            props.view === "Responsable_Sanciones"
                          )) ||
                        // (userRoles.length > 0 &&
                        //   !(
                        //     userRoles.includes("Responsable_Sanciones") ||
                        //     userRoles.includes("Encargado_Sanciones") ||
                        //     userRoles.includes("administrador")
                        //   )) ||
                        (props.edit &&
                          props.editItem.list_caso_disciplinario[0]
                            .fecha_cierre)
                      }
                    ></Typeahead>
                    {responsableLoading && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                    {touched.id_responsable && errors.id_responsable && (
                      <div>
                        <small className="text-danger">
                          {errors.id_responsable}
                        </small>
                      </div>
                    )}
                    {loaderDiciplinaryCase && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Categoria de desvinculación
                    </Form.Label>
                    <Typeahead
                      id="categoria_desvinculacion"
                      name="categoria_desvinculacion"
                      isInvalid={
                        touched.categoria_desvinculacion &&
                        errors.categoria_desvinculacion
                      }
                      isValid={
                        touched.categoria_desvinculacion &&
                        !errors.categoria_desvinculacion
                      }
                      onBlur={handleBlur("categoria_desvinculacion")}
                      placeholder="Seleccione una categoria de desvinculación"
                      options={categoryOptions}
                      onChange={(selected) => {
                        setFieldValue(
                          "categoria_desvinculacion",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setCatSelected(selected);
                      }}
                      selected={catSelected}
                      disabled={
                        (props.view &&
                          !(
                            props.view === "administrador" ||
                            props.view === "Encargado_Sanciones" ||
                            props.view === "Responsable_Sanciones"
                          )) ||
                        // (userRoles.length > 0 &&
                        //   !(
                        //     userRoles.includes("Responsable_Sanciones") ||
                        //     userRoles.includes("Encargado_Sanciones") ||
                        //     userRoles.includes("administrador")
                        //   )) ||
                        (props.edit &&
                          props.editItem.list_caso_disciplinario[0]
                            .fecha_cierre)
                      }
                    ></Typeahead>
                    {loadingUnlinkCategories && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                    {touched.categoria_desvinculacion &&
                      errors.categoria_desvinculacion && (
                        <div>
                          <small className="text-danger">
                            {errors.categoria_desvinculacion}
                          </small>
                        </div>
                      )}
                  </Form.Group>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="rounded-pill"
                variant="secondary"
                onClick={() => {
                  setEmailArray([]);
                  props.handleClose();
                }}
              >
                Cancelar
              </Button>
              {props.view &&
              (
                props.view === "administrador" ||
                props.view === "Encargado_Sanciones" ||
                props.view === "Responsable_Sanciones"
              ) &&
              // userRoles.length > 0 &&
              // (userRoles.includes("Responsable_Sanciones") ||
              //   userRoles.includes("Encargado_Sanciones") ||
              //   userRoles.includes("administrador"))
              (!props.edit ||
                (props.edit &&
                  !props.editItem.list_caso_disciplinario[0].fecha_cierre)) ? (
                <Button
                  disabled={saveLoading}
                  className="rounded-pill"
                  variant="primary"
                  type="submit"
                >
                  {saveLoading ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              ) : null}
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default Disciplinary_Actions_Modal;
